export default __webpack_public_path__ + "static/media/property_92.b47a22ef.png";